const typeMap = {
  ACTIVE: 'Active',
  BOOKED: 'Booked',
  CANCELLED: 'Cancelled',
  HANDLED: 'Handled',
  NOTIFIED: 'Notified Business',
  PROVIDED_INFO: 'Provided Info',
  RESCHEDULED: 'Rescheduled',
  UNRESPONSIVE: 'Unresponsive',
  WENT_QUIET: 'Went Quiet',
  ENGAGED: 'Engaged',
};

const typeMapFitness = {
  ACTIVE: 'Active',
  BOOKED: 'Class Enrollments',
  CANCELLED: 'Class Cancellations',
  HANDLED: 'Handled',
  NOTIFIED: 'Notified Business',
  PROVIDED_INFO: 'Provided Info',
  RESCHEDULED: 'Rescheduled',
  UNRESPONSIVE: 'Unresponsive',
  WENT_QUIET: 'Went Quiet',
  MEMBERSHIP_PURCHASE: 'Membership Requests',
  MEMBERSHIP_CANCEL: 'Membership Cancellation',
  ENGAGED: 'Engaged',
};

const colorMap = {
  ACTIVE: '#61b56b',
  BOOKED: '#6BA126',
  CANCELLED: '#24B4D5',
  HANDLED: '#A4B351',
  NOTIFIED: '#DDA068',
  PROVIDED_INFO: '#96ADB9',
  RESCHEDULED: '#B7DBF4',
  UNRESPONSIVE: '#4e6672',
  WENT_QUIET: '#6A68D3',
};

const conversationSourceKind = {
  ALL: 'All',
  MISSED_CALL: 'Missed Call',
  DIRECT_TEXT: 'SMS',
  LEAD_ENGAGE: 'Lead Engage',
  WEB_CHAT: 'Web Chat',
  WEB_TO_TEXT: 'Web to text',
  WEB_STORE: 'Online booking',
  INCOMING_VOICE_CALL: 'Voice AI Call',
};

const rangeType = {
  SEVEN_DAYS: 'Last 7 days',
  FOUR_WEEKS: 'Last 4 weeks',
  THREE_MONTHS: 'Last 3 months',
  SIX_MONTHS: 'Last 6 months',
};

const guestType = {
  ALL: 'All guests',
  NEW: 'New guests',
  EXISTING: 'Existing guests',
};

export {
  typeMap, typeMapFitness, colorMap, conversationSourceKind, rangeType, guestType,
};
